import React from 'react';

// ===========================|| LOGO SVG ||=========================== //

const Logo = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="190" height="40" viewBox="0 0 508 102">
        <text
            id="PAGOMUNDO"
            transform="matrix(2.54 0 0 2.55 24.732 76.114)"
            fill="#313131"
            fontFamily="Lato"
            fontWeight="900"
            fontVariant="small-caps"
            fontSize="28"
        >
            P<tspan fontSize="25.89">AGO</tspan>
            <tspan fill="#419388">
                M<tspan fontSize="25.89">UNDO</tspan>
            </tspan>
        </text>
    </svg>
);

export default Logo;
